import { render, staticRenderFns } from "./RecentVisits.vue?vue&type=template&id=1a6f41cc&scoped=true&"
import script from "./RecentVisits.vue?vue&type=script&lang=js&"
export * from "./RecentVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f41cc",
  null
  
)

export default component.exports